export var onRouteUpdate = function onRouteUpdate(_ref) {
  var location = _ref.location;
  var pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    stripQueryString: false
  };
  var domElem = document.querySelector("link[rel='canonical']");
  var existingValue = domElem.getAttribute("href");
  var baseProtocol = domElem.getAttribute("data-baseProtocol");
  var baseHost = domElem.getAttribute("data-baseHost");

  if (existingValue && baseProtocol && baseHost) {
    var value = "".concat(baseProtocol, "//").concat(baseHost).concat(location.pathname);
    var stripQueryString = pluginOptions.stripQueryString;

    if (!stripQueryString) {
      value += location.search;
    }

    value += location.hash;
    domElem.setAttribute("href", "".concat(value));
  }
};